jQuery(window).load(function(){
    if (jQuery(window).width() > 1050) {
        setTimeout(function(){
            skrollr.init({
                forceHeight: false,
            });
        }, 100);
    }
});
